






import { IStoreReferenceItem } from "@/store/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action } from "vuex-class";

@Component({})
export default class StoreReferenceItem extends Vue {
    @Prop()
    public storeReferenceItem: IStoreReferenceItem;

    @Action("fetchAlbum")
    public fetchAlbum: any;

    @Action("openGallery")
    public openGallery: any;

    public getBackgroundImageLink() : string {
        return "url(" + process.env.VUE_APP_DOMAIN + "/media/" + this.storeReferenceItem.src + ")";
    }
}
